import React, { ReactNode, useEffect, useRef } from 'react';
import { Box } from '@mui/material';

type Props = {
  children: ReactNode;
  maxHeight?: number | string;
  autoScroll?: boolean;
};

const MessageFeed: React.FC<Props> = ({ children, maxHeight = '100%', autoScroll = true }) => {
  const bottomRef = useRef<HTMLDivElement>(null);
  const prevCountRef = useRef<number>(0);

  const childCount = React.Children.count(children);

  useEffect(() => {
    // Only auto-scroll when a new message is appended to the feed
    if (autoScroll && childCount > prevCountRef.current) {
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
    prevCountRef.current = childCount;
  }, [childCount, autoScroll]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        maxHeight,
        height: '100%',
        p: 1,
        gap: 0.75,
        scrollbarWidth: 'none', // Firefox
        msOverflowStyle: 'none', // IE and Edge
        '&::-webkit-scrollbar': {
          display: 'none', // Chrome, Safari, Opera
        },
      }}
    >
      {children}
      <div ref={bottomRef} />
    </Box>
  );
};

export default MessageFeed;
